/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Text } from "components/Text";
import { FitinsurAPI, MessageCenter } from "utils";
import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import { Content, LayoutCircle, Section, Spacer } from "./styles";

const StepNavigation = ({ idOperation, idProduct, stage, ignoreOperationRoot, permissions }) => {
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const mc = new MessageCenter();
  const [isMasterPolicy, setIsMasterPolicy] = useState(null);
  const [operation, setOperation] = useState({});

  function getOperationInfo() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur
      .requestOperationInfo(idOperation)
      .then((response) => response.json())
      .then((response) => {
        setOperation(response);
        setIsMasterPolicy(
          response.isMasterPolicy || response.isMasterPolicyRoot
        );
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data: \n" + error);
      });
  }

  useEffect(() => {
    getOperationInfo();
  }, []);

  const checkOperationRoute = (idOperation, step) => {
    if (stage === step) return;

    fitinsur.setAuthToken(authContext.token);
    loading.start();

    fitinsur
      .requestPolicyNavigation(idOperation)
      .then((x) => x.json())
      .then((res) => {
        loading.stop();
        if (res.ret_code !== 200) {
          mc.error(res.ret_msg_details);
          return;
        }

        let {
          route,
          idOperationRoot,
          idProduct,
          idDomain,
          idNavigation,
          lastOperationQuestionnaireId,
          isBound,
        } = res.ret_value;
        if (step !== 3 || route) {
          if (step == 1) history.push(`/edit-enquiry/${idProduct}/${idOperation}`,
            { idProduct: idProduct, disabled: idOperationRoot === null, endorsement: idOperation || false });

          if (step == 2 && operation?.idDomainStatusDocument) history.push({ pathname: `/quote/plans/${idProduct || 34}/${idOperation}` });

          if (step == 3 && (permissions.DOCUMENT_GENERAL || permissions.ORDER_TO_BIND_GENERATE )) history.push({ pathname: route });
        } else {
          loading.stop();
        }
      }).catch((e) => loading.stop());
  };

  return (
    <Content>
      <Section>
        <LayoutCircle
          isActive={stage === 1}
          onClick={() => checkOperationRoute(idOperation, 1)}
        >
          {" "}
          1{" "}
        </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true}>
          INFORMAÇÕES BÁSICAS
        </Text>
      </Section>

      <Spacer className="d-sm-none"></Spacer>
      <Section>
        <LayoutCircle
          isActive={stage === 2}
          onClick={() => checkOperationRoute(idOperation, 2)}
        >
          {" "}
          2{" "}
        </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true}>
          INFORMAÇÕES DO SEGURO<br /> E PAGAMENTO
        </Text>
      </Section>

      <Spacer className="d-sm-none"></Spacer>
      <Section>
        <LayoutCircle
          isActive={stage === 3}
          onClick={() => checkOperationRoute(idOperation, 3)}
        >
          {" "}
          3{" "}
        </LayoutCircle>
        <Text className="d-none d-sm-block" spaceLeft={true}>
          APÓLICE E CONDICOES GERAIS
        </Text>
      </Section>
    </Content>
  );
};

export default StepNavigation;
